'use client';

import { c as _c } from "react/compiler-runtime";
import { type ComponentProps } from 'react';
import { LinkBase } from './i18n-navigation';
import { LinkStatusInjector } from './link-status-injector';
export const Link = t0 => {
  const $ = _c(9);
  let children;
  let prefetch;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      prefetch,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = prefetch;
    $[3] = rest;
  } else {
    children = $[1];
    prefetch = $[2];
    rest = $[3];
  }
  const shouldDisablePrefetch = typeof window === "undefined" ? prefetch : window.PUBLIC_ENV.disableNextPrefetchFeature === "true";
  const t1 = !shouldDisablePrefetch;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LinkStatusInjector />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children || $[6] !== rest || $[7] !== t1) {
    t3 = <LinkBase {...rest} prefetch={t1}>{t2}{children}</LinkBase>;
    $[5] = children;
    $[6] = rest;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};